export default "__VITE_ASSET__BWa5$oUy__"